import type { SVGProps } from "react";
// generated from CloudDone.svg — do not edit manually
// prettier-ignore
export default function CloudDone(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 20 10.758 C 21.206 11.565 22 12.94 22 14.5 C 22 16.985 19.985 19 17.5 19 H 6.5 C 4.015 19 2 16.985 2 14.5 C 2 12.156 3.792 10.231 6.08 10.019 C 6.548 7.172 9.02 5 12 5 C 14.221 5 16.16 6.207 17.197 8 M 23 5 L 12 16 L 8 12" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
